<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />

    <v-row>
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto"
      >
      <span class="float-right">
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                class="accent--text"
                :class="{'v-list-item--active': $route.name === 'PeopleInActivity'}"
                @click="showTargetGroupMembers"
              >
                <v-list-item-title>{{ $t('people') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'BoostersInActivity'}"
                @click="showTargetGroupOwners"
              >
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p
          v-if="tgId == targetGroup.id"
          :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
          :align="mobile() ? 'center' : 'left'"
        >
          {{ targetGroup.attributes.name }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        class="mx-auto custom-tab-menu py-0"
      >
        <v-list
          class="py-0"
          flat
        >
          <v-list-item
            class="accent--text"
            :class="{'v-list-item--active': $route.name === 'PeopleInActivity'}"
            @click="showTargetGroupMembers"
          >
            {{ $t('people') }}
          </v-list-item>
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'BoostersInActivity'}"
            @click="showTargetGroupOwners"
          >
            {{ $t('owners') }}
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row
      v-if="(!users || users.length == 0) && usersInfo.currentPage == 1 && !loadingData"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptytargetGroupPageTitle')"
          :page-text="$t('emptytargetGroupPageText')"
          page-image="image1"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
            <v-col 
                cols="11"
                class="d-flex justify-left align-center "
              >
                <v-avatar
                  size="38"
                  class="ml-4 mr-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="delete-user-tg-item"
                      router
                      @click.stop="
                        selectedUserForDeletion= user.attributes.email,
                        dialogVisibleRemoveUser=true,
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromTargetGroup'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveUserFromTargetGroup'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                align="center"
                class="d-flex justify-center align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>

              <v-col
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </div>
              </v-col>

              <v-col
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="delete-user-tg-item"
                      router
                      @click.stop="
                        selectedUserForDeletion= user.attributes.email,
                        dialogVisibleRemoveUser=true,
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromTargetGroup'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveUserFromTargetGroup'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
    />

    <!--float button -->
    <v-menu
      ref="menuRef"
      offset-y
      top
    >
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            data-testid="edit-target-group-button"
            color="accent"
            fixed
            right
            bottom
            fab
            large
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <v-list data-testid="menu-list">
        <v-list-item
          data-testid="add-people-tg-item"
          @click="addPeople"
        >
          <v-list-item-title class="pr-2">
            {{ $t('addPeople') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          data-testid="edit-tg-item"
          router
        >
          <v-list-item-title> 
            <EditTargetGroup
              :target-group-name="targetGroup.attributes?targetGroup.attributes.name:''"
              :target-group-id="tgId"
              @proceedSubmit="updateTargetGroup"
              @closeMenu="closeMenu"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          data-testid="delete-tg-item"
          router 
          @click.stop="
            dialogVisible=true,
            confirmationDialogTitle=$t('confirmationDialogTitleDeleteTargetGroup'),
            confirmationDialogText=$t('confirmationDialogTextDeleteTargetGroup'),
            confirmationDialogSubmitBtn=$t('delete')
            confirmationDialogCancelBtn=$t('no')"
        >
          <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!--END float button -->

    <ConfirmationDialog
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog"
      @close="dialogVisible=false"
      @proceedSubmit="deleteTargetGroup"
    />
    <ConfirmationDialog
      v-if="dialogVisibleRemoveUser"
      ref="confirmationDialogRemoveUser"
      :visible="dialogVisibleRemoveUser"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-user" 
      @close="dialogVisibleRemoveUser=false"
      @proceedSubmit="removeUserFromTargetGroup(selectedUserForDeletion)"
    />      
  </nav>
</template>    
<script>
import i18n from '../../plugins/i18n'
import EmptyPage from '../../components/EmptyPage'
import { deleteTargetGroup, getTargetGroupUsers, removeUserFromTargetGroup } from '../../api/targetGroupApi'
import EditTargetGroup from './EditTargetGroup'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import Pagination from '../../components/Pagination'
import AlertMessages  from '../../components/AlertMessages'
export default {
    components: { 
        EmptyPage,
        EditTargetGroup,
        ConfirmationDialog,
        Pagination,
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],

    data(){
        return{
            readonly: true,
            users: [],
            tgId: this.$route.params.id,
            spaceId: window.$cookies.get('space_id'),
            userId: window.$cookies.get('id'),
            alertMsg: '',
            alertType:'',
            alertValue:false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            dialogVisible: false,
            dialogVisibleRemoveUser: false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            usersInfo: { 
                currentPage: 1,
                total: 0,
            },
            pageNumber: 1,
            size: 15,
            loadingData: false
        }

    },
    computed:{
      targetGroup() {
        return this.$store.state.targetGroup
      }
    },
    mounted() {
      this.getTargetGroup()
    },
    async created(){
        if(this.$route.params.successfullyCreatedTargetGroup){
            this.alertType = 'success'
            this.alertMsg = i18n.t('newTargetGroupMsg')
            this.alertValue = true
        }
        if(this.$route.params.successfullyAddedPeople){     
            this.alertType = 'success'
            this.alertMsg = i18n.t('addPeopleToTgMsgSuccess')
            this.alertValue = true
        }

        this.loadingData = true
        await this.fetchUsers()
        this.loadingData = false
    },
    methods: {
        addPeople(){
            this.$router.push({path: '/target-group/'+this.tgId+'/add-people'})
        },
        getTargetGroup(){
         this.$store.dispatch("getTargetGroup", this.tgId);
        },
        updateTargetGroup(msg, type, name){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.$store.state.targetGroup.attributes.name = name
            if(msg != ''){
                this.closeMenu()
            }
        },
        showTargetGroupMembers(){
            if (this.$route.name != 'ViewTargetGroup') {
                this.$router.push({path: '/target-group/'+ this.tgId})
            }
        },
        showTargetGroupOwners(){
            if (this.$route.name != 'BoostersInTargetGroup') {
                this.$router.push({path: '/target-group/'+ this.tgId +'/owners'})
            }
        },
        closeMenu(){
            this.$refs.menuRef.isActive = false
        },
        async deleteTargetGroup(){
            this.dialogVisible = false
            try{
                let data = {
                    data: {
                        type: "target-groups",
                        id: this.tgId,
                        attributes: {
                            deleted_at: this.currentDate()
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            }
                        }
                    }
                }
                const response = await deleteTargetGroup(this.tgId, data)
                if(response.status == 200) {
                    this.$router.push({name: 'TargetGroups', params: { successfullyDeletedTargetGroup: true}})
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            this.alertValue = true
                            if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                this.$router.push({name: 'PageAccessDenied'})
                            }
                            else {
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError')
                            }
                        }
                    } else{
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async fetchUsers(){
            try {
                const response = await getTargetGroupUsers(this.tgId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        window.scrollTo(0,0)
                        this.usersInfo = response.data.meta
                    }
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                        this.alertValue = true
                    }
                }
            }
        },

        async removeUserFromTargetGroup(email){
            this.dialogVisibleRemoveUser = false
            try{
                let data = {
                    data: {
                        type: "target-group-users", 
                        attributes: {
                            user_email: email
                        },
                    }
                }
                const response = await removeUserFromTargetGroup(this.tgId, data)
                if(response.status == 200) {
                    await this.fetchUsers()
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeUserFromTargetGroupSuccess')
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else{
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async handlePageChange(value){
            this.loadingData = true
            this.usersInfo.currentPage = value
            this.pageNumber = value
            await this.fetchUsers()
            this.loadingData = false
        },
    }
}
</script>
